import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e6db6ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-renderer-id"]
const _hoisted_2 = {
  key: 0,
  class: "color-red"
}
const _hoisted_3 = {
  key: 0,
  class: "color-red"
}
const _hoisted_4 = ["id", "value", "disabled", "placeholder", "onInput", "data-id"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!

  return (_ctx.control.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "repeatable-control mb-2",
        "data-renderer-id": 
      _ctx.RendererConfigurations.RepeatableStringControlRenderer.name
    
      }, [
        (_ctx.tooltip)
          ? (_openBlock(), _createBlock(_component_ElTooltip, {
              key: 0,
              effect: "custom",
              content: _ctx.tooltip,
              placement: "left"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", {
                  class: _normalizeClass([_ctx.styles.control.label, "font-size-14"])
                }, [
                  _createTextVNode(_toDisplayString(_ctx.control.label), 1),
                  (_ctx.control.required)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _: 1
            }, 8, ["content"]))
          : (_openBlock(), _createElementBlock("label", {
              key: 1,
              class: _normalizeClass([_ctx.styles.control.label, "font-size-14"])
            }, [
              _createTextVNode(_toDisplayString(_ctx.control.label), 1),
              (_ctx.control.required)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
                : _createCommentVNode("", true)
            ], 2)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (element, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${_ctx.control.path}-${index}`,
            class: "d-flex flex-row align-items-center repeatable-row"
          }, [
            _createElementVNode("input", {
              id: `${_ctx.control.id}-${index}-input`,
              class: _normalizeClass([
          _ctx.styles.control.input,
          { 'required-border': _ctx.isItemInvalid(element) },
        ]),
              value: element,
              disabled: !_ctx.control.enabled,
              placeholder: _ctx.placeholder,
              type: "text",
              onInput: ($event: any) => (_ctx.onItemInput(index, $event)),
              "data-id": `${_ctx.dataIdPrefix}-${index}-input`
            }, null, 42, _hoisted_4),
            (index === _ctx.items.length - 1 && !_ctx.isAddDisabled)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-link repeatable-btn add-btn",
                  disabled: !_ctx.control.enabled,
                  title: "Add",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)))
                }, " + ", 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-link repeatable-btn remove-btn",
              disabled: !_ctx.control.enabled || _ctx.isRemoveDisabled,
              title: "Remove",
              onClick: ($event: any) => (_ctx.removeRow(index))
            }, " × ", 8, _hoisted_6)
          ]))
        }), 128)),
        (_ctx.items.length === 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn-link repeatable-btn add-btn",
              disabled: !_ctx.control.enabled,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)))
            }, " + " + _toDisplayString(_ctx.control.label), 9, _hoisted_7))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}